/* eslint-disable @typescript-eslint/no-unused-vars */
import { createEffect } from "effector"

import { FeedbackReason, type FeedbackSubmitPayload } from "../shared/types"

// TODO: Move to environment variables or configuration and change endpoint
// Google Form configuration
const GOOGLE_FORM_ACTION_URL = `https://docs.google.com/forms/u/0/d/e/${GOOGLE_FORM_ID}/formResponse`

const GOOGLE_FORM_ENTRY_IDS = {
  reasons: "entry.478356292", // Checkboxes field
  missingFeaturesText: "entry.966862348", // Missing features text field
  otherOptionResponse: "entry.478356292.other_option_response" // Other option in checkbox
}

// Mapping of internal reason values to Google Form display values
const REASON_LABELS: Record<FeedbackReason, string> = {
  [FeedbackReason.notWithinBudget]: "Not within my budget",
  [FeedbackReason.missingFeatures]: "Missing features I need",
  [FeedbackReason.noTimeToTest]: "Didn’t have time to test it properly",
  [FeedbackReason.other]: "__other_option__" // Special value for "Other" checkbox
}

export const submitFeedbackFx = createEffect<FeedbackSubmitPayload, void, Error>(async (data) => {
  try {
    const formData = new FormData()

    data.reasons.forEach((reason) => {
      formData.append(GOOGLE_FORM_ENTRY_IDS.reasons, REASON_LABELS[reason])
    })

    if (data.otherText) {
      formData.append(GOOGLE_FORM_ENTRY_IDS.otherOptionResponse, data.otherText)
    }

    if (data.missingFeaturesText) {
      formData.append(GOOGLE_FORM_ENTRY_IDS.missingFeaturesText, data.missingFeaturesText)
    }

    // Submit to Google Form
    // Note: Using no-cors mode because Google Forms doesn't allow CORS
    await fetch(GOOGLE_FORM_ACTION_URL, {
      method: "POST",
      body: formData,
      mode: "no-cors"
    })
  } catch (error) {
    throw new Error("Failed to submit feedback")
  }
})
